import React from 'react';
import './FeedFilters.css';

const FILTER_OPTIONS = [
  { id: 'all', labelEn: 'All', labelHe: '\u05D4\u05DB\u05DC', sources: null },
  { id: 'alerts', labelEn: 'AI Alerts', labelHe: '\u05D4\u05EA\u05E8\u05D0\u05D5\u05EA AI', sources: ['ai_alert'] },
  { id: 'news', labelEn: 'News', labelHe: '\u05D7\u05D3\u05E9\u05D5\u05EA', sources: ['dental_news'] },
  { id: 'activity', labelEn: 'Activity', labelHe: '\u05E4\u05E2\u05D9\u05DC\u05D5\u05EA', sources: ['practice_activity'] },
  { id: 'wins', labelEn: 'Wins', labelHe: '\u05D4\u05D9\u05E9\u05D2\u05D9\u05DD', sources: ['clinical_win'] },
];

export const FeedFilters = ({
  activeFilters = {},
  onChange,
  language = 'he',
}) => {
  const isHebrew = language === 'he';
  const activeId = activeFilters.sources
    ? FILTER_OPTIONS.find(
        (f) =>
          f.sources &&
          f.sources.length === activeFilters.sources.length &&
          f.sources.every((s) => activeFilters.sources.includes(s))
      )?.id || 'all'
    : 'all';

  const handleFilterClick = (filter) => {
    onChange({ sources: filter.sources });
  };

  return (
    <div className="feed-filters">
      {FILTER_OPTIONS.map((filter) => (
        <button
          key={filter.id}
          className={`filter-chip ${activeId === filter.id ? 'active' : ''}`}
          onClick={() => handleFilterClick(filter)}
        >
          {isHebrew ? filter.labelHe : filter.labelEn}
        </button>
      ))}
    </div>
  );
};
